import Vue from 'vue'
import Vuex from 'vuex'
import customers from "@/store/modules/customers/customers";
import authenticate from "@/store/modules/authenticate/authenticate";
import orders from "@/store/modules/orders/orders";
import products from "@/store/modules/product/product";
import deboters from "@/store/modules/deboters/deboters";
import requests from "@/store/modules/requests/requests";
import bankinfo from "@/store/modules/contradiction/bankinfo";
import dashboard from "@/store/modules/dashboard/dashboard";
import axios from "axios";
import questions from "@/store/modules/questions/question";
import users from "@/store/modules/users/users";
import buys from "@/store/modules/buys/Buys";
import agents from "@/store/modules/agents/agents";
import targets from "@/store/modules/target/target";
import drivers from "@/store/modules/drivers/drivers";
import finnotech from "@/store/modules/finnotech/fonntech";


Vue.use(Vuex)

const store = new Vuex.Store({
    plugins: [],
    state: {
        //baseUrl:'http://localhost:5000',
        baseUrl: 'https://ecap-api-v1.ailand.ai',
        appTitle: 'ایکپ۲',
        appVersion: '2.4.8.0',
        rabbitmqClient: undefined,
        watcherId: undefined,
        checkList: [],  
        accessToken: null,
        userName: '',
        roles: '',
        isLogged: false,
        jwtType: 'Bearer ',
        userMobile: '',
        phone: '',
        internalUserMobile: '',
        internalUserMobile2: '',
        avayaExt: '',
        postfixPhone1: '',
        postfixPhone2: '',
        postfixPhone3: '',
        firstName: '',
        lastName: '',
        applicationRoles: ['admin', 'superuser', 'user', 'salemanager', 'edit_customer'],
        socket: {
            isConnected: false,
            message: '',
            reconnectError: false,
        },
        mobileTableHeight: '400px',
        desktopTableHeight: '700px',
        uuid: '',
        storeAccessList: [],
        issueOrderRemittanceStoreList: [],
        userId: undefined,
        profitInfo:[],
        visitLogTypeList: [
            {Id: 1, title: 'درخواست خرید', name: 'BuyRequest'},
            {Id: 2, title: 'پیگیری', name: 'FollowUp'},
            {Id: 3, title: 'گزارش کار', name: 'WorkReport'},
            {Id: 4, title: 'فروش', name: 'Sale'},
            {Id: 5, title: 'پیشنهاد', name: 'Proposal'},
            {Id: 6, title: 'تماس ورودی', name: 'ّIncomingCall'},
            {Id: 7, title: 'تماس خروجی موفق', name: 'SuccessOutgoingCall'},
            {Id: 8, title: 'تماس خروجی ناموفق', name: 'FailedOutgoingCall'},
            {Id: 9, title: 'بازدید در محل', name: 'OnSiteVisit'},
            {Id: 10, title: 'تحویل بار', name: 'CargoDelivery'},
            {Id: 11, title: 'همه موارد', name: 'AllItems'}
        ],
        organizeUnit: [
            {Id: 1, title: 'فروش', name: 'user_sell'},
            {Id: 1, title: 'خرید', name: 'user_purchase'},
            {Id: 1, title: 'انبار', name: 'user_store'},
            {Id: 1, title: 'مالی', name: 'user_finance'}
        ],
        timeLineOptions: [
            {id: 1, label: 'کسری کالا', value: 'کسری کالا', buy: false},
            {id: 2, label: 'کمبود اعتبار', value: 'کمبود اعتبار', buy: false},
            {id: 3, label: 'پیش فاکتور', value: 'پیش فاکتور', buy: false},
            {id: 4, label: 'عدم احراز صلاحیت', value: 'عدم احراز صلاحیت', buy: false},
            {id: 5, label: 'قیمت کالا بالا است', value: 'قیمت کالا بالا است', buy: false},
            {id: 6, label: 'آرشیو', value: 'آرشیو', buy: false},
            {id: 7, label: 'جاری', value: 'جاری', buy: false},
            {id: 8, label: 'سفارش به طرف معامله تحویل داده شود', value: 'سفارش به طرف معامله تحویل داده شود', buy: false},
            {id: 9, label: 'انتقال بین انبارها', value: 'انتقال بین انبارها', buy: false},
            {id: 10, label: 'متفرقه', value: 'متفرقه', buy: false},
            {id: 11, label: 'حذف', value: 'حذف', buy: false},
            {id: 12, label: 'نحوه بازپرداخت فاکتور', value: 'نحوه بازپرداخت فاکتور', buy: false},
            {
                id: 13,
                label: 'تاییدیه هماهنگی با طرف معامله جهت تحویل کالا',
                value: 'تاییدیه هماهنگی با طرف معامله جهت تحویل کالا',
                buy: false
            },
            {id: 14, label: 'برگشت سفارش', value: 'برگشت سفارش', buy: false},
            {id: 15, label: 'کمبود اعتبار', value: 'کمبود اعتبار', buy: true},
            {id: 16, label: 'قیمت کالا بالا است', value: 'قیمت کالا بالا است', buy: true},
            {id: 17, label: 'جاری', value: 'جاری', buy: true},
            {id: 18, label: 'متفرقه', value: 'متفرقه', buy: true},
            {
                id: 19,
                label: 'تاییدیه هماهنگی با طرف معامله جهت دریافت کالا',
                value: 'تاییدیه هماهنگی با طرف معامله جهت دریافت کالا',
                buy: true
            },
            {id: 18, label: 'پیگیری', value: 'پیگیری', buy: true},
            {id: 19, label: 'توضیحات مشتری', value: 'توضیحات مشتری', buy: false},
        ],
        balanceInfo:undefined,
        financeServiceStatus:undefined
    },
    mutations: {
        SOCKET_ONOPEN(state, event) {
            Vue.prototype.$socket = event.currentTarget
            state.socket.isConnected = true
        },
        SOCKET_ONCLOSE(state) {
            state.socket.isConnected = false
        },
        SOCKET_ONERROR(state, event) {
            console.error(state, event)
        },
        SOCKET_ONMESSAGE(state, message) {
            state.socket.message = message
        },
        SOCKET_RECONNECT(state, count) {
            console.info(state, count)
        },
        SOCKET_RECONNECT_ERROR(state) {
            state.socket.reconnectError = true;
        },
    },
    actions: {
        async getRoles() {
            let response = await axios.get(`/get_roles`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async sendBatchSNS(context, payload) {
            let response = await axios.post(`/send_batch_sms_to_customers`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async sendMessage(context, payload) {
            let response = await axios.get(`/run_conference_agent_customer/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async send_sms_by_user(context, payload) {
            let response = await axios.post(`/send_scheduled_sms_by_user`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async isCallCenterLive(context, payload) {
            let response = await axios.get(`/call_center_is_live/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        }
    },
    modules: {
        Authenticate: authenticate,
        Orders: orders,
        Customers: customers,
        Products: products,
        Deboters: deboters,
        Requests: requests,
        BankInfo: bankinfo,
        Dashboard: dashboard,
        Questions: questions,
        Users: users,
        Buys:buys,
        Agents:agents,
        Targets:targets,
        Drivers: drivers,
        Finnotech: finnotech
    }
});
export default store;
